import { valueByProp } from "./value-by-prop";

export const indexByProp = (arr: Array<any>, prop: string, value: string | number | boolean): number => {
  let index = -1;
  let check;

  for (let i = 0, ii = arr?.length; i < ii; i += 1) {
    check = valueByProp(arr[i], prop);

    if (Array.isArray(check)) {
      if (check.indexOf(value) !== -1) {
        index = i;
        break;
      }
    } else {
      if (check === value) {
        index = i;
        break;
      }
    }
  }

  return index;
};
